const price_compare = {
  title: 'Confronto Prezzi',
  placeholder: 'Sezione in costruzione. Funzionalità in arrivo.',
  logs_title: 'Storico log',
  log_label: 'Log #{id}',
  no_logs: 'Nessun log presente',
  log_details_title: 'Dettagli log #{id}',
  simulate_title: 'Simulazione',
  card_customer_title: 'Cliente',
  card_product_title: 'Prodotto',
  card_prices_title: 'Prezzi',
  customer_id: 'ID',
  customer_name: 'Nome',
  customer_username: 'Username',
  product_code: 'Codice',
  product_description: 'Descrizione',
  product_class_code: 'Codice classe',
  product_manufacturer_code: 'Codice produttore',
  product_cati_code: 'Codice CATI',
  product_manufacturer_name: 'Produttore',
  product_ls: 'LS',
  customers_title: 'Clienti',
  col_username: 'Username',
  col_password: 'Password',
  col_actions: 'Azioni',
  add_user: 'Aggiungi cliente',
  edit_user: 'Modifica',
  delete_user: 'Elimina',
  save_user: 'Salva',
  cancel_edit: 'Annulla',
  delete_confirm_title: 'Elimina cliente',
  delete_confirm_message: 'Sei sicuro di voler eliminare questo cliente?',
  form_create_title: 'Nuovo cliente',
  form_username: 'Username',
  form_password: 'Password',
  form_create_btn: 'Crea',
  form_cancel_btn: 'Annulla',
  products_title: 'Prodotti',
  all_customers: 'Tutti i clienti',
  find_product: 'Cerca prodotto',
  no_products: 'Nessun prodotto',
  remove_product: 'Rimuovi prodotto',
  empty_customers: 'Seleziona almeno un cliente',
  mixed: 'mix',
  simulate_action: 'Simula',
  simulation_ongoing: 'Simulazione in corso...',
  generate_random: 'Genera casuale',
  generate_random_title: 'Genera prodotti casuali',
  generate_random_message:
    'I prodotti attualmente selezionati verranno cancellati e sostituiti con prodotti casuali per ogni cliente. Continuare?',
}

export default price_compare
